export default __webpack_public_path__ + "static/media/sailthru.122aa662.png";